(() => {
	let e = window.Difrax?.sectionLifecycle,
		t = new WeakMap(),
		n = null,
		r = null,
		i = (e) => {
			let t = document.querySelector(`[data-collection-ajax-status]`);
			!t ||
				!e ||
				((t.textContent = ``),
				window.requestAnimationFrame(() => {
					t.textContent = e;
				}));
		},
		a = (e) => {
			let a = e.dataset.ajaxNavigation === `true`,
				o = window.matchMedia(`(min-width: 990px)`),
				s = `mainCollectionFilters:${e.dataset.sectionId}`,
				c = e.dataset.collectionFilterMode === `toolbar-drawer`,
				l = () => e.querySelector(`[data-collection-filters]`),
				u = () => e.querySelectorAll(`[data-filter-toggle]`),
				d = 0,
				f = 0,
				p = () => {
					e.style.removeProperty(`--main-collection-filter-offset-block-start`);
				},
				m = () => {
					let t = l();
					if (!c || !t || !o.matches) {
						p();
						return;
					}
					let n = e.dataset.collectionFilterOffsetRoot,
						r = e.dataset.collectionFilterOffsetTarget,
						i = n ? e.querySelector(n) : null,
						a = r ? e.querySelector(r) : null;
					if (!i || !a) {
						p();
						return;
					}
					let s =
						a.getBoundingClientRect().bottom - i.getBoundingClientRect().top;
					e.style.setProperty(
						`--main-collection-filter-offset-block-start`,
						`${Math.round(s)}px`,
					);
				},
				h = () => {
					m();
				},
				g = () => {
					d && window.cancelAnimationFrame(d),
						(d = window.requestAnimationFrame(() => {
							(d = 0), h();
						}));
				},
				_ = (e) => {
					u().forEach((t) => {
						t.setAttribute(`aria-expanded`, String(e));
					});
				},
				v = (t) => {
					e.toggleAttribute(`data-filters-collapsed`, t), _(!t);
				},
				y = () => {
					l()?.classList.remove(`is-open`),
						document.documentElement.classList.remove(
							`main-collection-filter-open`,
						),
						_(!1);
				},
				b = () => {
					l()?.classList.add(`is-open`),
						document.documentElement.classList.add(
							`main-collection-filter-open`,
						),
						_(!0);
				},
				x = () => {
					f && window.cancelAnimationFrame(f),
						(f = window.requestAnimationFrame(() => {
							f = window.requestAnimationFrame(() => {
								(f = 0), e.removeAttribute(`data-restoring-mobile-drawer`);
							});
						}));
				},
				S = () => {
					if (l()) {
						if (c) {
							o.matches
								? (y(), v(sessionStorage.getItem(s) === `collapsed`))
								: (e.removeAttribute(`data-filters-collapsed`), _(!1)),
								g();
							return;
						}
						o.matches
							? (y(), v(sessionStorage.getItem(s) === `collapsed`))
							: (e.removeAttribute(`data-filters-collapsed`), _(!1)),
							g();
					}
				};
			e.addEventListener(`click`, (t) => {
				let n = t.target;
				if (n?.closest(`[data-filter-toggle]`)) {
					if (c) {
						if (o.matches) {
							let t = !e.hasAttribute(`data-filters-collapsed`);
							v(t), sessionStorage.setItem(s, t ? `collapsed` : `expanded`);
						} else b();
						return;
					}
					if (o.matches) {
						let t = !e.hasAttribute(`data-filters-collapsed`);
						v(t), sessionStorage.setItem(s, t ? `collapsed` : `expanded`);
					} else b();
					return;
				}
				if (n?.closest(`[data-filter-close]`)) {
					y();
					return;
				}
				let r = n?.closest(`[data-filter-show-more]`);
				r &&
					(r
						.closest(`.main-collection__filter`)
						?.querySelectorAll(`[data-filter-extra-value]`)
						.forEach((e) => {
							e.hidden = !1;
						}),
					(r.hidden = !0),
					g());
			}),
				document.addEventListener(`keydown`, (e) => {
					e.key === `Escape` && y();
				});
			let C = async (
				r,
				{
					preserveMobileDrawer: s = !1,
					scrollToTop: c = !1,
					updateHistory: u = !0,
				} = {},
			) => {
				if (!a) {
					window.location.href = r.toString();
					return;
				}
				n?.abort();
				let d = new AbortController();
				n = d;
				let f = Array.from(document.querySelectorAll(`[data-main-collection]`)),
					p = s && !o.matches && !!l()?.classList.contains(`is-open`);
				try {
					f.forEach((e) => {
						e.setAttribute(`aria-busy`, `true`);
					});
					let n = await fetch(r.toString(), {
						headers: { "X-Requested-With": `XMLHttpRequest` },
						signal: d.signal,
					});
					if (!n.ok) throw Error(`HTTP ${n.status}`);
					let a = await n.text();
					if (d.signal.aborted) return;
					let o = new DOMParser().parseFromString(a, `text/html`),
						s =
							o
								.querySelector(`[data-collection-result-message]`)
								?.dataset.collectionResultMessage?.trim() ?? ``;
					p && e.setAttribute(`data-restoring-mobile-drawer`, ``);
					let l = 0;
					if (
						(f.forEach((e) => {
							let t = e.dataset.sectionId,
								n = t
									? o.querySelector(
											`[data-main-collection][data-section-id="${t}"]`,
										)
									: null;
							n &&
								((e.innerHTML = n.innerHTML),
								window.Difrax?.sectionLifecycle?.runAll?.(e, {
									reason: `ajax-navigation`,
								}),
								(l += 1));
						}),
						l === 0)
					)
						throw Error(`Collection sections not found`);
					u && window.history.pushState({}, ``, r.toString()),
						c && window.scrollTo({ top: 0, left: 0, behavior: `auto` }),
						f.forEach((e) => {
							t.get(e)?.sync();
						}),
						p ? (b(), x()) : y(),
						i(s);
				} catch {
					if (
						(e.removeAttribute(`data-restoring-mobile-drawer`),
						d.signal.aborted)
					)
						return;
					window.location.href = r.toString();
				} finally {
					n === d &&
						((n = null),
						f.forEach((e) => {
							e.removeAttribute(`aria-busy`);
						}));
				}
			};
			return (
				a && (r = C),
				e.addEventListener(`click`, (e) => {
					if (!a) return;
					let t = e.target?.closest(
						`.main-collection__pagination a, .main-collection__active-chip, .main-collection__clear-all, .main-collection__filter-option`,
					);
					!t ||
						t.target ||
						e.defaultPrevented ||
						(e.preventDefault(),
						C(new URL(t.href, window.location.href), {
							preserveMobileDrawer: !t.closest(`.main-collection__pagination`),
							scrollToTop: !!t.closest(`.main-collection__pagination`),
						}));
				}),
				e.addEventListener(`change`, (e) => {
					let t = e.target?.closest(`[data-collection-sort-select]`);
					if (!t) return;
					let n = new URL(window.location.href);
					n.searchParams.set(`sort_by`, t.value),
						n.searchParams.delete(`page`),
						C(n);
				}),
				e.addEventListener(`submit`, (e) => {
					if (!a) return;
					let t = e.target?.closest(`.main-collection__filters-form`);
					if (!t) return;
					e.preventDefault();
					let n = new URL(t.action, window.location.href);
					(n.search = ``),
						new FormData(t).forEach((e, t) => {
							n.searchParams.append(t, String(e));
						}),
						n.searchParams.delete(`page`),
						C(n, { preserveMobileDrawer: !0 });
				}),
				o.addEventListener?.(`change`, S),
				window.addEventListener(`resize`, g),
				window.addEventListener(`load`, g, { once: !0 }),
				new ResizeObserver(g).observe(e),
				S(),
				g(),
				window.setTimeout(g, 250),
				window.setTimeout(g, 1e3),
				{
					sync() {
						S(), g();
					},
				}
			);
		},
		o = (e) => {
			if (t.has(e)) return;
			let n = e;
			(n.dataset.filtersInitialized = `true`), t.set(n, a(n));
		},
		s = (e) => {
			t.get(e)?.sync();
		},
		c = () => {
			document.querySelectorAll(`[data-main-collection]`).forEach(o);
		};
	if (e) {
		e.register({
			name: `main-collection`,
			selector: `[data-main-collection]`,
			init: o,
			update: s,
		});
		return;
	}
	document.readyState === `loading`
		? document.addEventListener(`DOMContentLoaded`, c, { once: !0 })
		: c(),
		window.addEventListener(`load`, c, { once: !0 }),
		window.addEventListener(`popstate`, () => {
			r?.(new URL(window.location.href), { updateHistory: !1 });
		});
})();
